// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CloseSmallHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="10"
            height="10"
            fill="currentColor"
        >
            <path
                d="M73.7062502,237.29375 C74.0968752,237.684375 74.0968752,238.317187 73.7062502,238.707812 C73.5124998,238.903125 73.2562504,239 72.9999995,239 C72.7437496,239 72.4881248,238.902344 72.2931252,238.707031 L68.9999995,235.415625 L65.7071877,238.70625 C65.5118752,238.903125 65.2559376,239 64.9999995,239 C64.7440624,239 64.4884372,238.903125 64.2929683,238.70625 C63.9023433,238.315625 63.9023433,237.682813 64.2929683,237.292188 L67.5867186,233.998438 L64.2929683,230.70625 C63.9023433,230.315625 63.9023433,229.682813 64.2929683,229.292188 C64.6835933,228.901563 65.3164058,228.901563 65.7070308,229.292188 L68.9999995,232.5875 L72.2937493,229.29375 C72.6843743,228.903125 73.3171868,228.903125 73.7078118,229.29375 C74.0984368,229.684375 74.0984368,230.317187 73.7078118,230.707812 L70.414062,234.001562 L73.7062497,237.29375 L73.7062502,237.29375 Z"
                transform="translate(-64 -229)"
            />
        </svg>
    );
};

export default React.memo(CloseSmallHover);
